import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';

const Profile = ({firstName, lastName, email, phone}) => {
    return (
        <Card style={{ margin: 20 }}>
            <CardContent>
                <Typography variant="h5">
                    {firstName} {lastName}
                </Typography>
                <Typography color="textSecondary">
                    {email}
                </Typography>
                <Typography color="textSecondary">
                    {phone}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default Profile;
